import { render, staticRenderFns } from "./ImgCheckbox.vue?vue&type=template&id=0567461c&scoped=true"
import script from "./ImgCheckbox.vue?vue&type=script&lang=js"
export * from "./ImgCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ImgCheckbox.vue?vue&type=style&index=0&id=0567461c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567461c",
  null
  
)

export default component.exports